import React from 'react';
import { Card, CardHeader, Grid, List, ListItem, ListItemText } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

const Dashboard = () => (
  <Grid container spacing={3} data-testid="dashboard">
    <Grid item md={3}>
      <Card>
        <CardHeader title="External resources" data-testid="dashboard-external-resources-title" />
        <List>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://medely.atlassian.net/servicedesk/customer/portal/1"
            data-testid="dashboard-submit-an-ideia"
          >
            <ListItemText
              primary="Product Bugs and Service Requests"
              secondary="Submit product bugs or service requests"
            />
            <OpenInNew color="action" />
          </ListItem>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://www.notion.so/medely/Ideas-34a739e0a32b80a0a00de920b9676127?source=copy_link"
            data-testid="dashboard-product-ideas"
          >
            <ListItemText
              primary="Product Ideas and Feature Requests"
              secondary="Submit a new product idea or feature request to the Product Team"
            />
            <OpenInNew color="action" />
          </ListItem>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://medely.siit.io/home"
            data-testid="dashboard-medely-it-support"
          >
            <ListItemText
              primary="Medely IT Support"
              secondary="Submit a ticket, check status of a ticket, review help articles"
            />
            <OpenInNew color="action" />
          </ListItem>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://medely.atlassian.net/servicedesk/customer/portal/4"
            data-testid="dashboard-business-intelligence"
          >
            <ListItemText
              primary="Business Intelligence"
              secondary="Submit a request to the Business Intelligence Team"
            />
            <OpenInNew color="action" />
          </ListItem>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://help.medely.com"
            data-testid="dashboard-help-article"
          >
            <ListItemText
              primary="Facility/Pro help articles"
              secondary="Advice and answers from the Medely Team for facilities and professionals"
            />
            <OpenInNew color="action" />
          </ListItem>
          <ListItem
            button
            component="a"
            target="_blank"
            href="https://docs.google.com/spreadsheets/d/1Sbi8DiaRp9nHIDJ5dcj57ld2eYBx4RVkLDYvJ2Lzll0/edit#gid=1566394050"
            data-testid="dashboard-verification"
          >
            <ListItemText
              primary="License & Credentials Verification"
              secondary="State by state resource for license verification"
            />
            <OpenInNew color="action" />
          </ListItem>
        </List>
      </Card>
    </Grid>
  </Grid>
);

export default Dashboard;
